import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { kebabCase } from 'lodash';
import { enabledSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
const SegmentedButton = _ref => {
  let enabled = _ref.enabled,
    onChange = _ref.onChange,
    active = _ref.active,
    option = _ref.option,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label;
  let classNames = "t-sb t-sb-".concat(label && label.length ? "".concat(kebabCase(label), "-") : '').concat(kebabCase(option.identifier));
  classNames += active ? ' t-sb-active' : '';
  return /*#__PURE__*/React.createElement(Button, {
    "data-testid": "sb-".concat(kebabCase(option.title)),
    disabled: !enabled,
    active: active,
    onClick: () => onChange(option),
    className: classNames,
    style: {
      flex: 1
    }
  }, option.title);
};
SegmentedButton.propTypes = {
  label: PropTypes.string,
  active: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  option: PropTypes.shape({
    identifier: PropTypes.string,
    title: PropTypes.string
  }).isRequired
};
export { SegmentedButton as UncomposedSegmentedButton };
export default entityComposition(SegmentedButton, [], {
  enabled: enabledSelector
});